import '@fancyapps/fancybox';

let fancyboxes = function ($) {
  $('[data-fancybox]').fancybox({
    buttons: [
      'fullScreen',
      'close'
    ]
  });
};
export default fancyboxes;



// WEBPACK FOOTER //
// ./app/blocks/fancybox/fancybox.js